import React from 'react';
import GirlsWithJar from '../../../assets/images/occupational_theropy/girs_with_jar.jpg';
import { motion } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';

const Benefits = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const TitleAndDescription = ({ title, description }) => {
    return (
      <div className="flex-1 flex flex-col gap-2">
        <h2 className="text-[28px] sm:text-[34px] text-primary font-bold">
          {title}
        </h2>
        <p
          className="text-secondary text-lg 2xl:text-2xl"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    );
  };

  return (
    <div className="bg-[#F0EFEF]">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
        <div>
          <h2 className="text-[38px] sm:text-[40px] md:text-[54px] text-primary font-bold leading-tight">
            Benefits of Guidepost Pediatric <br />
            Occupational Therapy
          </h2>
        </div>
        <div className="mt-2">
          <TitleAndDescription
            title="Pediatric occupational therapy offers several benefits for children,
            including:"
          />
        </div>
        <div className="mt-14 flex flex-col md:flex-row gap-10 xl:gap-24">
          <div className="flex-1 flex flex-col justify-between gap-5">
            <TitleAndDescription
              title="Enhancing Motor Skills"
              description="Occupational therapists help children develop fine motor skills, coordination, and hand-eye coordination necessary for activities like writing, using utensils, and tying shoelaces."
            />
            <TitleAndDescription
              title="Promoting Independence"
              description="Occupational therapy supports children in achieving greater independence in self-care tasks such as dressing, grooming, and feeding."
            />
            <TitleAndDescription
              title="Enhancing Cognitive Skills"
              description="Through engaging activities, occupational therapy stimulates cognitive development, including problem-solving, memory, attention, and organization."
            />
            <TitleAndDescription
              title="Sensory Integration"
              description="Occupational therapists work with children to manage sensory sensitivities, improve sensory processing, and develop strategies for sensory regulation."
            />
          </div>
          <div className="flex-1 flex flex-col justify-between gap-8">
            <motion.div
              initial={{ opacity: 0, x: isMobile ? 0 : 300 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.9, ease: 'easeOut' }}
              viewport={{ once: true, amount: 0.5 }}
              className="w-full rounded-lg overflow-hidden"
            >
              <img
                src={GirlsWithJar}
                alt="Occupational therapist guiding child in Wasilla session"
                className="w-full h-[500px] sm:h-[550px] md:h-[600px] object-cover rounded-lg"
              />
            </motion.div>

            <div className="flex-1 flex items-end">
              <TitleAndDescription
                title="Building Social Skills"
                description="Occupational therapy helps children improve social interaction, emotional regulation, and social skills necessary for successful relationships and peer interactions.
"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
